import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getProbabilities = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/probabilities', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getProbabilitiesAll = () => {
  return api.http.get(`/probabilities/select_search`)
}

export const getProbability = id => {
  return api.http.get(`/probabilities/${id}`)
}

export const searchProbabilities = term => {
  return api.http.get('/probabilities/select_search', {
    params: {
      term
    }
  })
}

export const getSelectProbabilities = (term, callback) => {
  searchProbabilities(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteProbability = id => {
  return api.http.delete(`/probabilities/${id}`)
}

export const restoreProbability = id => {
  return api.http.put(`/probabilities/${id}/restore`)
}

export const editProbability = probability => {
  return api.http.put(`/probabilities/${probability._id}`, probability)
}

export const addProbability = probability => {
  return api.http.post('/probabilities', probability)
}



// WEBPACK FOOTER //
// ./src/api/probabilities.js